// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_f7-0";
export var optionCard = "_f7-1";